import { Ref } from "vue";

export const toolbarHeight = "40px";

export type CardPosition = {
  xLeft: string;
  xRight?: string;
  yTop: string;
  yBottom: string;
};

export type LastMaxSize = {
  width: string;
  height: string;
};

export function foldDirection(el: Ref<HTMLElement>, mode: "min" | "max", height: number): "upwards" | "downwards" {
  const inLowerScreenHalf = el.value.getBoundingClientRect().top >= height - el.value.getBoundingClientRect().bottom;

  if (mode === "min") {
    return inLowerScreenHalf ? "downwards" : "upwards";
  } else {
    return inLowerScreenHalf ? "upwards" : "downwards";
  }
}
